import axios from 'axios';
import { config } from '../config/config';

class DatabaseChatService {
  constructor() {
    this.baseUrl =config.api.baseUrl.replace('/v1', '') ;
    this.userId = this.generateUserId();
  }

  generateUserId() {
    let userId = localStorage.getItem('chat_user_id');
    if (!userId) {
      userId = `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('chat_user_id', userId);
    }
    return userId;
  }

  async sendMessage(message, sessionId, conversationHistory = []) {
    console.log('sendMessage called with history length:', conversationHistory.length);
    try {
      // Convert conversation history to API format (exclude the welcome message)
      const apiMessages = conversationHistory
        .filter(msg => msg.text !== "Hello! I'm your askSRE Assistant. How can I help you today?")
        .map(msg => ({
          role: msg.sender === 'user' ? 'user' : 'assistant',
          content: msg.text
        }));
      
      console.log('API Messages being sent:', apiMessages);

      const payload = {
        model: "askSRE",
        user: this.userId,
        session_id: sessionId,
        messages: apiMessages
      };

      const response = await axios.post(`${this.baseUrl}/v1/chat/completions`, payload, {
        timeout: 60000, // 60 second timeout
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return { message: response.data?.choices?.[0]?.message?.content || "No response" };
    } catch (error) {
      console.error("Chat API error:", error);
      if (error.code === 'ECONNABORTED') {
        return { error: "Request timeout - please try again" };
      }
      return { error: "Failed to send message" };
    }
  }

  async getSessions() {
    try {
      const response = await axios.get(`${this.baseUrl}/v1/sessions/${this.userId}`, {
        timeout: 10000
      });
      return response.data.sessions || [];
    } catch (error) {
      console.error("Error fetching sessions:", error);
      return [];
    }
  }

  async getSession(sessionId) {
    try {
      const response = await axios.get(`${this.baseUrl}/v1/sessions/${this.userId}/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching session:", error);
      return null;
    }
  }

  async deleteSession(sessionId) {
    try {
      await axios.delete(`${this.baseUrl}/v1/sessions/${this.userId}/${sessionId}`);
      return true;
    } catch (error) {
      console.error("Error deleting session:", error);
      return false;
    }
  }

  async clearAllSessions() {
    try {
      await axios.delete(`${this.baseUrl}/v1/sessions/${this.userId}`);
      return true;
    } catch (error) {
      console.error("Error clearing sessions:", error);
      return false;
    }
  }
}

export const databaseChatService = new DatabaseChatService();